import axiosInstance from '../../../../../utils/axios';
import { URLS } from '../../../../../utils/constants/urls';

export const getCountry = async () => {
  const { status, data } = await axiosInstance.get(URLS.countries);
  if (status === 200) {
    return data;
  }
};
export const getState = async (id: number) => {
  const { status, data } = await axiosInstance.get(URLS.state(id));
  if (status === 200) {
    return data;
  }
};
export const getCity = async (id: number) => {
  const { status, data } = await axiosInstance.get(URLS.city(id));
  if (status === 200) {
    return data;
  }
};
